<div>
    <h2 class="widget-header h4 sr-only" i18n="@@kpi-charts">KPI Charts</h2>
    <span class="text-muted sr-only" i18n="@@kpi-charts-sub-title">
        Charts visualising KPI measurement and other goals for the organisation.
    </span>
    <div *ngIf="activeGroups$ | async as charts; else loading" class="row">
        <div *ngFor="let chart of charts" class="pt-3 pb-3 chart-container col" [ngClass]="setSizeClass(chart)">
            <div *ngIf="chart"  class="chart align-items-center">
                    <div *ngIf="chart.ChartType === 2" class="flex-fill align-items-center h-100">
                        <h3 class="h4 widget-header chart-title-wrap pb-2" i18n="chart group name@@chart-group-name">{{chart.GroupName}}</h3>
                        <app-bar-chart [chart]="chart"></app-bar-chart>
                    </div>

                    <div *ngIf="chart.ChartType === 1" class="flex-fill align-items-center h-100">
                        <h3 class="h4 widget-header chart-title-wrap pb-2" i18n="chart group name@@chart-group-name">{{chart.GroupName}}</h3>
                        <app-pie-chart [chart]="chart"></app-pie-chart>
                    </div>
            </div> <!-- box area -->
        </div>
    </div>
</div>

<ng-template #loading>
    <div *ngIf="errorSubject$ | async as err; else innerLoading">
        <app-error-templates [error]="err.status" [componentName]="componentName"></app-error-templates>
    </div>
    <ng-template #innerLoading>
        <div>
            <app-widget-placeholder></app-widget-placeholder>
        </div>
    </ng-template>
</ng-template>